import React from "react";
import intl from "react-intl-universal";
import * as S from './styled'

interface ItemsSummaryProps {
  totalLinesSelected: number;
  totalQuantity: Record<string, number>;
  totalLot: Record<string, number>;
}

const ItemsSummary: React.FC<ItemsSummaryProps> = ({
  totalLinesSelected,
  totalQuantity,
  totalLot,
}) => {
  const parseObjectUnits = (object: Record<string, number>): string =>
    Object.keys(object).length > 0
      ? Object.entries(object)
        .map(([unit, qty]) => `${qty} ${unit}`)
        .join(", ")
      : "";
  const lotString = totalLot && parseObjectUnits(totalLot);
  const totalQuantityString = totalQuantity && parseObjectUnits(totalQuantity);


  return (
    <S.Wrapper>
      <S.StepBadge>{totalLinesSelected} {intl.get("commons.rowsSelected")}</S.StepBadge>
      <S.TextBlock>
        <span>
          {`${intl.get("commons.qtdTotal")}: ${totalQuantityString}`}
        </span>
        {lotString && (
          <span>{`${intl.get("commons.lotTotal")}: ${lotString}`}</span>
        )}
      </S.TextBlock>
    </S.Wrapper>
  );
};

export default ItemsSummary;
